
<template>
      <v-container
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card :loading="loading" v-show="!show2FAForm" class="elevation-12 mt-12" >
              <v-toolbar
                color="secondary"
                dark
                flat
              >
                <v-toolbar-title>Авторизація</v-toolbar-title>
                <v-spacer />
               
              </v-toolbar>
              <v-card-text>
                <v-form 
                
                ref="form"
                v-model="valid"
                lazy-validation>
                  <v-text-field
                    @keyup.enter="auth()"
                    ref="login"
                    v-model="login"
                    label="Ім'я користувача"
                    name="login"
                    :counter="20"
                    :rules="loginRules"
                    prepend-icon="person"
                    type="text"
                    required
                  />

                  <v-text-field
                    @keyup.enter="auth()"
                    v-model="password"
                    id="password"
                    label="Пароль"
                    name="password"
                    :rules="passwordRules"
                    prepend-icon="lock"
                    type="password"
                    required
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn class="d-none" text small color="grey">Реєстрація</v-btn>
                <v-spacer />
                <v-btn :loading="loading" color="primary" @click="auth()">Увійти</v-btn>
              </v-card-actions>
            </v-card>

            <v-card :loading="loading" v-show="show2FAForm" class="elevation-12 mt-12" >
              <v-toolbar
                color="secondary"
                dark
                flat
              >
                <v-toolbar-title>Двоетапна перевірка</v-toolbar-title>
                <v-spacer />
               
              </v-toolbar>
              <v-card-text>
                <v-img 
                :src="qr_code"
                width="250"
                max-width="250"
                class="mx-auto"
                 />
                <v-form 
                @submit.prevent="send2FACode()"
                ref="formfa"
                v-model="valid2"
                lazy-validation>
                  <v-text-field
                    
                    ref="facode"
                    v-model="code"
                    label="Код перевірки"
                    name="facode"
                    :counter="6"
                    :rules="codeRules"
                    prepend-icon="lock"
                    type="text"
                    required
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="primary" @click="clear2FALogic()">Скинути</v-btn>
                <v-spacer />
                <v-btn :loading="loading" color="primary" @click="send2FACode()">Надіслати</v-btn>
              </v-card-actions>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
</template>


<script>
import axios from "axios"
//simport Cookies from 'js-cookie'
export default {
  name: 'login',
  data: () => ({
    loading: false,
    sheet: false,
    valid: true,
    valid2: true,
    is2FASetupRequired: false,
    show2FAForm: false,
    twoFactorToken: '',
    code: '',
    qr_code: '',
    login: '',
    codeRules: [
      v => !!v || "Обов'язкове поле",
      v => (v && v.length == 6) || "Код перевірки має складатись з 6-ти цифр",
      
    ],
    loginRules: [
      v => !!v || "Обов'язкове поле",
      v => (v && v.length <= 20) || "Ім'я не повинно бути більше 20-ти символів",
      
    ],
    password: '',
    passwordRules: [
      v => !!v || "Обов'язкове поле",
    ],
  }),
  mounted() {
    this.$nextTick(function () {
      this.clear2FALogic()
      this.$refs.login.focus()
      this.$refs.login.focus()
    }) 
  },
  
  methods: {
    validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          //console.log(this.snackbar);
        }
    },
    clear2FALogic(){
      this.qr_code = ''
      this.is2FASetupRequired = false
      this.show2FAForm = false
      this.twoFactorToken = ''
      this.code = ''
    },

    async send2FACode() {
      
      let url = this.is2FASetupRequired && "/api/user/2fa/confirm/" || "/api/user/2fa/verify/"
      if(this.$refs.formfa.validate()){
        this.loading = true
        await axios({
          method: "post",
          headers: { "Content-type": "application/json; charset=UTF-8" },
          url: url,
          data: {"two_factor_token": this.twoFactorToken, otp_code: this.code}
        })
          .then(response => {
            
            if(response){
              this.$store.dispatch('auth/saveToken', {
                token_access: response.data.access,
                token_refresh: response.data.refresh, 
              }
              )
              const next = this.$route.query.next || {name: "home"} 
              this.$router.push(next)
            }else{
              this.$router.app.$sheet.show("Помилка!", "Щось пішло не так");
            }
          })
          .catch(err => {
              console.log("error auth", err);
              this.$router.app.$sheet.show("Помилка!", err);
          })
          .finally(() => (this.loading = false))
        }
    },
    async send2FAToken() {
        this.loading = true
        await axios({
          method: "post",
          headers: { "Content-type": "application/json; charset=UTF-8" },
          url: "/api/user/2fa/setup/",
          data: {"two_factor_token": this.twoFactorToken}
        })
          .then(response => {
            
            if(response){
              console.log(response.data)
              this.show2FAForm = true
              this.qr_code = response.data.qr_code
              setTimeout(() => {
                this.$refs.facode.focus()
              }, 100);
              

            }else{
              //
            }
          })
          .catch(err => {
              console.log("error auth", err);
              this.$router.app.$sheet.show("Помилка!", err);
          })
          .finally(() => (this.loading = false))
    },
    async auth() {
      
      this.twoFactorToken = ''
      if(this.$refs.form.validate()){
        this.loading = true
        await axios({
          method: "post",
          headers: { "Content-type": "application/json; charset=UTF-8" },
          url: "/api/user/token/",
          data: {"username": this.login, "password": this.password}
        })
          .then(response => {
            if(response){
            /* Якщо повертається статус двофакторної аутентифікації - робимо запит з токеном  */
            if(response.data.status == "2fa_setup_required"){
              this.is2FASetupRequired = true // для qr code
              this.twoFactorToken = response.data.two_factor_token
              this.send2FAToken()
              return
            }
            /**------------------------------------------------------------------------------ */
            /* Якщо двофакторна аутентифікація вже була сконфігурована - просимо ввести код перевірки  */
            if(response.data.status == "2fa_required"){
              this.is2FASetupRequired = false
              this.twoFactorToken = response.data.two_factor_token
              this.show2FAForm = true
              setTimeout(() => {
                this.$refs.facode.focus()
              }, 100);
              this.loading = false
              return
            }
            /**------------------------------------------------------------------------------ */
            
              
          }else{
            this.$router.app.$sheet.show("Помилка!", "Невірний логін або пароль");
          }
          })
          .catch(err => {
              console.log("error auth", err);
             this.$router.app.$sheet.show("Помилка!", err);
          })
          .finally(() => (this.loading = false))
      }
      
    }

  }
};

</script>

<style lang="css">

</style>